"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RightsholderRateSheetDownloadLink_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRateSheetDownloadLink"));
require("../index.scss");
const RateSheetTypeTooltip_1 = __importDefault(require("@Components/RoyaltiesTable/RatesTable/RateSheetTypeTooltip"));
const RatesTable = ({ data, isProvisional }) => (react_1.default.createElement("div", { className: "royalties-table rates-table" },
    react_1.default.createElement("table", null,
        react_1.default.createElement("tbody", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("th", { className: "darkest" }, "Usage Period"),
                react_1.default.createElement("th", { className: "darkest" }, "DSP"),
                react_1.default.createElement("th", { className: "darkest no-right-border" },
                    "Rate Sheet ",
                    react_1.default.createElement(RateSheetTypeTooltip_1.default, { isProvisional: isProvisional }),
                    ' ')),
            data.map((row, idx) => {
                const usagePeriodDate = new Date(row.year, row.month - 1, 1);
                return (react_1.default.createElement("tr", { key: idx },
                    react_1.default.createElement("td", null, usagePeriodDate.toLocaleString('default', {
                        month: 'long',
                        year: 'numeric',
                    })),
                    react_1.default.createElement("td", { className: 'wide-column bold' }, row.dspName),
                    react_1.default.createElement("td", { className: 'no-right-border' },
                        react_1.default.createElement("div", { className: 'download-container' }, row.rateSheetLinks.map((rateSheetLink, sheetIdx) => (react_1.default.createElement(RightsholderRateSheetDownloadLink_1.default, { rateSheetLink: rateSheetLink, status: isProvisional
                                ? 'provisional'
                                : rateSheetLink.isOriginal
                                    ? 'original'
                                    : 'adjusted', key: `rate-sheet-${sheetIdx}` })))))));
            })))));
exports.default = RatesTable;
